import { connect } from "react-redux";
import Notifications from "react-notification-system-redux";

export const getNotifications = state => state.notifications;

export default connect(state => ({
  notifications: getNotifications(state)
}))(Notifications);



// WEBPACK FOOTER //
// ./src/components/generic/layout/Notifications/index.js